<template>
  <yioks-content @back="handleBack">
    <template v-slot:nav_left>
      <div class="nav-btn-box">
        <p class="btn active">申报评估考核阶段</p>
        <p class="btn" @click="toPath">历史文件库</p>
      </div>
    </template>
    <template v-slot:nav_right>
      <!-- <div v-if="!empty" class="yioks_btn" @click="handleSaveTemp">临时保存</div>
      <div v-if="!empty" class="yioks_btn" @click="handleAll">完成并提交</div> -->
    </template>

    <template v-slot:content_right>
      <div class="base-content-wrapper">
        <div class="content-inner-wrapper">
          <div class="list_wrap" v-if="!empty && !loading">
            <div class="tongji-wrapper">
              <vue-scroll>
                <div class="tongji-content">
                  <div class="progress-box">
                    当前申报材料完成总进度：
                    {{
                      submitedInfo && submitedInfo.totalProgress
                        ? submitedInfo.totalProgress + "%"
                        : "0%"
                    }}
                  </div>
                  <div v-if="isInClubSystem" class="progress-box n-mt">
                    专家审核进度：
                    {{ expertProgress }}%
                  </div>

                  <template v-if="isAudited">
                    <!-- 初审结果 -->
                    <template v-if="auditInfo.auditType === 1">
                      <div
                        class="info-box"
                        v-if="
                          auditInfo.auditState == 3 || auditInfo.auditState == 2
                        "
                      >
                        继续完善材料：{{ auditInfo.auditInfo || "无" }}
                      </div>
                      <div class="btn-box" v-if="auditInfo.auditState == 1">
                        您提交的申报信息已经区体育行政部门初审通过，请等待下一轮审核的结果。
                      </div>
                      <div class="btn-box" v-if="auditInfo.auditState == 2">
                        您提交的申报信息已经区体育行政部门初审拒绝。
                      </div>
                      <div class="btn-box" v-if="auditInfo.auditState == 3">
                        您提交的申报信息已经区体育行政部门初审驳回，点击<span
                          class="btn-span"
                          @click="handleRefuse"
                          >撤回提交</span
                        >，可重新编辑申报信息并再次提交审核。
                      </div>
                    </template>
                    <!-- 终审结果 -->
                    <template v-else-if="auditInfo.auditType === 2">
                      <div
                        class="info-box"
                        v-if="
                          auditInfo.auditState == 3 || auditInfo.auditState == 2
                        "
                      >
                        继续完善材料：{{ auditInfo.auditInfo }}
                      </div>
                      <div class="btn-box" v-if="auditInfo.auditState == 1">
                        您提交的申报信息已经上海市市体育局/足协终审通过。
                      </div>
                      <div class="btn-box" v-if="auditInfo.auditState == 2">
                        您提交的申报信息已经上海市市体育局/足协终审拒绝。
                      </div>
                      <div class="btn-box" v-if="auditInfo.auditState == 3">
                        您提交的申报信息已经上海市市体育局/足协终审驳回，点击<span
                          class="btn-span"
                          @click="handleRefuse"
                          >撤回提交</span
                        >，可重新编辑申报信息并再次提交审核。
                      </div>
                    </template>
<!--                    <div class="btn-span" style=" text-align: center;margin-top: 10px;" @click="viewScore" v-if="!isInClubSystem">-->
<!--                      查看专家评分-->
<!--                    </div>-->
                  </template>
                  <template v-else>
                    <template v-if="theEnd === 1">
                      <div class="btn-box">
                        当前评估考核阶段已结束，请等待审核结果。
                      </div>
<!--                      <div class="btn-span" style=" text-align: center;margin-top: 10px;" @click="viewScore" v-if="!isInClubSystem">-->
<!--                        查看专家评分-->
<!--                      </div>-->
                    </template>
                    <template v-else>
                      <!--<div class="btn-box">-->
                        <!--您提交的申报信息已经提交。-->
                      <!--</div>-->
                      <div class="btn-box">
                        您提交的申报信息已经提交，点击<span
                          class="btn-span"
                          @click="handleRefuse"
                          >撤回提交</span
                        >，可重新编辑申报信息并再次提交审核。
                      </div>
                    </template>
                  </template>

                  <div class="steps-box">
                    <el-steps
                      :active="activeStep"
                      finish-status="success"
                      simple
                      style="margin-top: 20px"
                    >
                      <el-step title="用户提交"> </el-step>
                      <el-step :title="secondStepName">
                        <!--
                          simple 模式下无效
                          <div slot="description">
                        {{ auditInfo.auditState }}
                        </div> -->
                      </el-step>
                      <el-step :title="thirdStepName"></el-step>
                    </el-steps>
                  </div>
                </div>
              </vue-scroll>
            </div>
          </div>

          <yioks-empty v-if="empty" tips="暂时没有数据"></yioks-empty>
          <yioks-loading v-if="loading"></yioks-loading>

          <yioks-tips
            :showTip="isShowRefuseDialog"
            tipMsg="确认撤回提交的申报信息吗？"
            @callback="handleConfirmRefuse"
          ></yioks-tips>

          <yioks-dialog
            :title="baseScoreInfoScore.name+'——专家评分：'+baseScoreInfo.scoreTotal + '分'"
            :show-flag="isShowDialog"
            :isShowCancel="false"
            :width="'630px'"
            :successBtn="'关闭'"
            @hideDialog="hideDialogFunction"
          >
            <div class="dialog-content">
              <vue-scroll :ops="ops">

                <div class="info">
                  <div class="col">
                    <span class="title">2024上半年工作总结及经费执行情况（{{baseScoreInfoScore['ce3b55a45a5f48a3b274eae1b1ac07dfScore']}}分）：</span>
                    <span class="score">{{ baseScoreInfo['ce3b55a45a5f48a3b274eae1b1ac07df'] || '--' }} 分</span>
                  </div>
                  <div class="col">
                    <span class="title">2024下半年工作计划及经费使用计划（{{baseScoreInfoScore['ee919079125a4fcf868226d3454d1a28Score']}}分）：</span>
                    <span class="score">{{ baseScoreInfo['ee919079125a4fcf868226d3454d1a28'] || '--' }} 分</span>
                  </div>
                  <div class="col">
                    <span class="title">足球场（{{baseScoreInfoScore['footballScore']}}分）：</span>
                    <span class="score">{{ baseScoreInfo.football || '--' }} 分</span>
                  </div>
                  <div class="col">
                    <span class="title">场地使用权限（{{baseScoreInfoScore['siteScore']}}分）：</span>
                    <span class="score">{{ baseScoreInfo.site || '--' }} 分</span>
                  </div>
                  <div class="col">
                    <span class="title">辅助配套设施（{{baseScoreInfoScore['facilitiesScore']}}分）：</span>
                    <span class="score">{{ baseScoreInfo.facilities || '--' }} 分</span>
                  </div>
                  <div class="col">
                    <span class="title">体教融合（{{baseScoreInfoScore['schoolScore']}}分）：</span>
                    <span class="score">{{ baseScoreInfo.school || '--' }} 分</span>
                  </div>
                  <div class="col">
                    <span class="title">机构梯队信息（{{baseScoreInfoScore['echelonScore']}}分）：</span>
                    <span class="score">{{ baseScoreInfo.echelon || '--' }} 分</span>
                  </div>
                  <div class="col">
                    <span class="title">教练员队伍（{{baseScoreInfoScore['coachScore']}}分）：</span>
                    <span class="score">{{ baseScoreInfo.coach || '--' }} 分</span>
                  </div>
                  <div class="col">
                    <span class="title">机构训练计划及实施情况（{{baseScoreInfoScore['trainScore']}}分）：</span>
                    <span class="score">{{ baseScoreInfo.train || '--' }} 分</span>
                  </div>
                  <div class="col">
                    <span class="title">举办活动情况（{{baseScoreInfoScore['4d67e56204bb4681a484e69fdf89b018Score']}}分）：</span>
                    <span class="score">{{ baseScoreInfo['4d67e56204bb4681a484e69fdf89b018'] || '--' }} 分</span>
                  </div>
                  <div class="col">
                    <span class="title">机构参加上海市、全国性的比赛（{{baseScoreInfoScore['matchScore']}}分）：</span>
                    <span class="score">{{ baseScoreInfo.match || '--' }} 分</span>
                  </div>
                  <div class="col">
                    <span class="title">机构人才输送参加上海足协、中国足协的集训活动（{{baseScoreInfoScore['campScore']}}分）：</span>
                    <span class="score">{{ baseScoreInfo.camp || '--' }} 分</span>
                  </div>
                  <div class="col">
                    <span class="title">特色工作（{{baseScoreInfoScore['a6514512c30d423c9b005a5cf5a8d064Score']}}分）：</span>
                    <span class="score">{{ baseScoreInfo['a6514512c30d423c9b005a5cf5a8d064'] || '--' }} 分</span>
                  </div>
                  <div class="col">
                    <span class="title">机构对健康向上的足球文化体系构建情况（{{baseScoreInfoScore['e26503b0faa74e98b36ef5e4f91289d4Score']}}分）：</span>
                    <span class="score">{{ baseScoreInfo['e26503b0faa74e98b36ef5e4f91289d4'] || '--' }} 分</span>
                  </div>
                </div>
              </vue-scroll>
            </div>
          </yioks-dialog>

        </div>
      </div>
    </template>
  </yioks-content>
</template>

<script>
import {
  orgAuditStageInfo,
  deleteTargetCompletedRevocation,
  baseScoreInfo,
} from "@/api/performance";
import { opsHorizontal } from "@/utils/scrollIndialog";
import storage from "@/utils/storage";
import { ops } from '@/utils/scrollIndialog';
import { auditStateFilters } from "@/assets/js/yioksFilters";
import mixinAppConfig from "@/mixin/mixinAppConfig";
export default {
  mixins: [mixinAppConfig],
  components: {
    "yioks-tips": () => import("@/components/YioksTip"),
  },

  data() {
    return {
      ops,
      opsHorizontal: opsHorizontal(),
      empty: false,
      loading: false,
      auditInfo: {},
      submitedInfo: {},

      isShowRefuseDialog: false,
      refuseForm: {
        msg: "",
      },
      isShowDialog: false,
      baseScoreInfo:{

      },
      baseScoreInfoScore:{

      },
      refuseFormRules: {},
      isAudited: false,
      activeStep: 1,
      expertProgress: 0,
      theEnd: 0,
    };
  },
  computed: {
    groupUuid() {
      const { groupUuid } = this.$route.query;
      return groupUuid;
    },
    stageUuid() {
      const { stageUuid } = this.$route.query;
      return stageUuid;
    },

    stageName() {
      const { stageName } = this.$route.query;
      return stageName;
    },

    stageType() {
      const { stageType } = this.$route.query;
      return Number(stageType) || 0;
    },

    secondStepName() {
      const clubConfig = this.$store.getters.sysHostType;
      if (clubConfig === "club") {
        return "专家审核";
      } else {
        return "区级审核";
      }
    },

    thirdStepName() {
      return "最终确认";
    },
  },

  // filters: {
  //   auditStateFilters
  // },

  created() {
    this.loadOrgAuditInfo();
  },

  methods: {
    auditStateFilters,
    handleBack() {
      this.$router.push("/");
    },

    loadOrgAuditInfo() {
      const paramsData = {
        stageUuid: this.stageUuid,
      };
      this.loading = true;
      orgAuditStageInfo(paramsData)
        .then((res) => {
          this.loading = false;
          if (res) {
            const {
              expertAuditSum,
              theEnd,
              expertSum,
              orgAuditStageLog,
              submit,
            } = res;
            if (theEnd !== undefined) this.theEnd = theEnd;
            if (orgAuditStageLog && orgAuditStageLog.uuid) {
              // 已审核
              this.auditInfo = orgAuditStageLog;
              this.isAudited = true;
              if (
                this.auditInfo.auditType == 1 ||
                this.auditInfo.auditType == 3
              ) {
                this.activeStep = 2; // 完成初审
              } else if (this.auditInfo.auditType == 2) {
                this.activeStep = 3; // 完成终审
              } else {
                this.activeStep = 1; // 其他状态默认第一步
              }
            } else {
              // 仅提交，未审核
              this.isAudited = false;
              this.activeStep = 1;
            }
            if (expertAuditSum && expertSum) {
              this.expertProgress = (
                (expertAuditSum / expertSum) *
                100
              ).toFixed(0);
            }
            this.submitedInfo = submit;
          } else {
            this.empty = true;
          }

          // console.log('this.activeStep', this.activeStep)
        })
        .catch((err) => {
          this.loading = false;
          console.error("err", err);
        });
    },

    handleRefuse() {
      this.isShowRefuseDialog = true;
    },

    viewScore() {
      baseScoreInfo(this.stageUuid)
      .then((res) => {
        if (res.code) {
          this.$message.error(res.msg);
          return;
        }
        this.baseScoreInfo = res.resultMap;
        this.baseScoreInfoScore = res.resultMapScore;
        this.isShowDialog= true;
      })
      .catch((err) => {
        console.error("err", err);
      });
    },
    hideDialogFunction (flag, ok) {
      if (ok) {
        this.isShowDialog = flag
      } else {
        this.isShowDialog = flag
      }
    },
    handleConfirmRefuse(flag, ok) {
      if (flag) {
        deleteTargetCompletedRevocation(this.stageUuid)
          .then((res) => {
            this.isShowRefuseDialog = false;
            if (res.code) {
              this.$message.error(res.msg);
              return;
            }
            this.$router.push({
              path: "uploadHome",
              query: {
                groupUuid: this.groupUuid,
                stageUuid: this.stageUuid,
                targetName: this.targetName,
                stageType: 0, // 撤回后请重新选择类型
              },
            });
          })
          .catch((err) => {
            console.error("err", err);
          });
      } else {
        console.log("cancel", "");
        this.isShowRefuseDialog = false;
      }
      // console.log('tag', '')
    },

    // 跳转
    toPath() {
      this.$router.push({
        path: "phaselist",
        query: {
          activeCom: "document-library",
          statusUrl: JSON.stringify(this.$route.fullPath),
        },
      });
    },
  },
};
</script>

<style lang="stylus" scoped>
@import '~@/assets/css/variable'
.content-inner-wrapper
  height 560px
  .select_wrap
    padding 20px 40px 20px
    min-height 40px
    display flex
    justify-content space-between
    width 100%
    .nav-btn
      width 50px
      display flex
      align-items center
      justify-content center
      cursor pointer
    .tag-box
      // flex 1
      width 680px
      margin 0 auto
      .scroll-wrapper
        display flex
        align-items center
        justify-content flex-start
        position absolute
    .tag-box1
      flex 1
      height 40px
.list_wrap
  flex 1
  overflow hidden
  .tongji-wrapper
    height 500px
    .tongji-content
      display flex
      flex-direction column
      .info-box
        display flex
        align-items center
        justify-content center
        margin 15px 0
        padding 0 100px
      .btn-box
        display flex
        align-items center
        justify-content center
.dialog-content
  width 100%
  height 320px
  padding 10px 0px 20px
  .info
    flex 1
    border 1px solid #4cd964
    border-bottom: none
  .col
    border-bottom 1px solid #4cd964
    // border-right 1px solid #FFF
    padding 16px 15px
    display flex
    justify-content space-around
    span
      display inline-block
      width 100%
    .title
      width 80%
    .score
      width 20%
.footer-btns
  width 60%
  display flex
  justify-content space-around
  margin 0 auto
.r-form
  /deep/.el-dialog__body
    padding 20px 40px 20px 20px
.btn-box
  font-size $font_size_big
.btn-span
  cursor pointer
  user-select none
  color $green_color
.progress-box
  height 60px
  display flex
  align-items center
  justify-content center
  font-size 1.8em
  margin-top 80px
  &.n-mt
    margin-top 0px
    margin-bottom 20px
</style>

<style lang="stylus" scoped>
@import '~@/assets/css/variable'
.nav-btn-box
  display flex
  .btn
    margin-right 20px
    padding 10px 15px
    cursor pointer
    user-select none
    &.active
      background-color $green_color
.steps-box
  border 2px solid $green_color
  box-sizing border-box
  margin 120px 20px 10px
  padding-bottom 20px
  border-radius 4px
  /deep/.el-steps--simple
    background none
  .el-step__title
    /deep/&.is-process
      color #fff
  .el-step__icon
    /deep/&.is-process
      color #fff !important
  .el-step__title
    /deep/&.is-wait
      color #ccc !important
  /deep/.el-step__head.is-process
    color #fff !important
    border-color #fff !important
  /deep/.el-step__head.is-wait
    color #ccc !important
    border-color #ccc !important
</style>
